var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestimonialPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 9C26 9.26518 25.9022 9.5195 25.728 9.70701C25.5539 9.89452 25.3177 9.99986 25.0715 9.99986L3.1716 9.99986L9.01565 16.291C9.19 16.4787 9.28795 16.7334 9.28795 16.9989C9.28795 17.2644 9.19 17.519 9.01565 17.7068C8.8413 17.8945 8.60484 18 8.35827 18C8.1117 18 7.87523 17.8945 7.70088 17.7068L0.272784 9.7079C0.186315 9.61502 0.117712 9.50468 0.0709029 9.38321C0.0240939 9.26174 -7.17508e-07 9.13151 -7.06483e-07 9C-6.95459e-07 8.86848 0.0240939 8.73826 0.0709029 8.61679C0.117712 8.49531 0.186315 8.38498 0.272784 8.2921L7.70088 0.293221C7.87523 0.105474 8.1117 2.96194e-08 8.35827 5.73336e-08C8.60484 8.50478e-08 8.84131 0.105475 9.01566 0.293221C9.19001 0.480968 9.28795 0.735608 9.28795 1.00112C9.28795 1.26664 9.19001 1.52128 9.01566 1.70902L3.1716 8.00014L25.0715 8.00014C25.3177 8.00014 25.5539 8.10548 25.728 8.29299C25.9022 8.4805 26 8.73482 26 9V9Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.00000579366,
    y1: 10.5273,
    x2: 21.2059,
    y2: -17.7122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialPrev);
export default __webpack_public_path__ + "static/media/testimonial--prev.4b35fac9a8e8beb825ceb52092007832.svg";
export { ForwardRef as ReactComponent };